import React from 'react';
import { View } from 'react-native';

export const FlexSpacer = (props: { flexAmount?: number }) => {
  const style = { flex: props.flexAmount || 1 };
  return <View style={style} />;
};
